import { render, staticRenderFns } from "./streaming.vue?vue&type=template&id=675c378e"
import script from "./streaming.vue?vue&type=script&lang=js"
export * from "./streaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports